<template>
  <div class="box box__selected">
    <div>
      <div class="box-title box-title__theme">
        {{$t('edit.sidebar.call_button_style')}}
      </div>
      <a @click="sidebarChangePanel('style');canvasChangeView('preview')" class="box-back">
        <i class="fa fa-arrow-left"></i> {{$t('general.actions.back')}}
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  methods: mapActions([
    'sidebarChangePanel',
    'canvasChangeView',
  ]),
};
</script>




/** WEBPACK FOOTER **
 ** Header.vue?ec763184
 **/